/**
 * CSRF Token Service
 * Provides CSRF token management for double-submit cookie pattern.
 */

/**
 * Get the CSRF token from the cookie
 * @returns The CSRF token or null if not set
 */
export function getCsrfToken(): string | null {
  const match = document.cookie.match(/csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Check if CSRF token is available
 * @returns true if CSRF token exists
 */
export function hasCsrfToken(): boolean {
  return getCsrfToken() !== null;
}

/**
 * Get headers with CSRF token included
 * Only adds token for state-changing methods
 * @param method HTTP method
 * @param existingHeaders Existing headers to merge with
 * @returns Headers with CSRF token if applicable
 */
export function getHeadersWithCsrf(
  method: string,
  existingHeaders: HeadersInit = {}
): HeadersInit {
  const stateChangingMethods = ['POST', 'PUT', 'PATCH', 'DELETE'];

  if (stateChangingMethods.includes(method.toUpperCase())) {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      return {
        ...existingHeaders,
        'X-CSRF-Token': csrfToken,
      };
    }
  }

  return existingHeaders;
}
